import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import FooterNavigation from './FooterNavigation.tsx';

interface PageLayoutProps {
  title: string;
  children: ReactNode;
  backText?: string;
  backTarget?: string;
  nextText?: string;
  nextTarget?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  title,
  children,
  backText,
  backTarget,
  nextText,
  nextTarget,
}) => {
  return (
    <Box maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        {title}
      </Typography>
      <Box mt={4} />
      {children}
      {(backText || nextText) && (
        <>
          <Box mt={4} />
          <FooterNavigation
            backText={backText}
            backTarget={backTarget}
            nextText={nextText}
            nextTarget={nextTarget}
          />
        </>
      )}
    </Box>
  );
};

export default PageLayout;